/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriveFilesResource } from '../models/DriveFilesResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CompanyImageService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Deposer une image de l'entreprise
     * `image` (jpg, png, gif, webp, 5 Mo max) pour le `type` : `background` (fond de l'application), `logo`, `entete` (en-tete des PDF) ou `icon` (icone PWA). Remplace l'image precedente du meme type.
     * @param companyId
     * @param formData
     * @returns DriveFilesResource `DriveFilesResource`
     * @throws ApiError
     */
    public companyImageUpload(
        companyId: number,
        formData: {
            image: Blob;
            type: 'background' | 'logo' | 'entete' | 'icon';
        },
    ): CancelablePromise<DriveFilesResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/company/{companyId}/images',
            path: {
                'companyId': companyId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer une image de l'entreprise
     * Retire l'image du `type` donne. Reponse : `{ message }` — precise s'il n'y avait rien a supprimer.
     * @param companyId
     * @param type
     * @returns any
     * @throws ApiError
     */
    public companyImageDelete(
        companyId: number,
        type: 'background' | 'logo' | 'entete' | 'icon',
    ): CancelablePromise<{
        message: 'Image supprimee' | 'Aucune image a supprimer';
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/company/{companyId}/images',
            path: {
                'companyId': companyId,
            },
            query: {
                'type': type,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Images d'une entreprise
     * Reponse : `{ background, logo, entete, icon }` avec, pour chaque image configuree, son `url` de telechargement temporaire (`null` sinon).
     * @param companyId
     * @returns string
     * @throws ApiError
     */
    public companyImageIndex(
        companyId: number,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/company/{companyId}/images',
            path: {
                'companyId': companyId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
